// OTA未処理予約 定数定義

// ステータス値
export const OTA_PENDING_STATUS = {
  DRAFT: 1,
  READY: 2,
  PROCESSED: 3,
  ERROR: 9,
  SKIPPED: 10,
} as const

// ステータスラベル
export const OTA_PENDING_STATUS_LABELS: Record<number, string> = {
  [OTA_PENDING_STATUS.DRAFT]: '下書き',
  [OTA_PENDING_STATUS.READY]: '準備OK',
  [OTA_PENDING_STATUS.PROCESSED]: '処理済み',
  [OTA_PENDING_STATUS.ERROR]: 'エラー',
  [OTA_PENDING_STATUS.SKIPPED]: 'スキップ',
}

export const OTA_PENDING_STATUS_KEYS: Record<string, number> = {
  draft: OTA_PENDING_STATUS.DRAFT,
  ready: OTA_PENDING_STATUS.READY,
  processed: OTA_PENDING_STATUS.PROCESSED,
  error: OTA_PENDING_STATUS.ERROR,
  skipped: OTA_PENDING_STATUS.SKIPPED,
}

// ステータス選択オプション
export const OTA_PENDING_STATUS_OPTIONS = [
  { id: 'draft', label: '下書き', value: String(OTA_PENDING_STATUS.DRAFT) },
  { id: 'ready', label: '準備OK', value: String(OTA_PENDING_STATUS.READY) },
  { id: 'processed', label: '処理済み', value: String(OTA_PENDING_STATUS.PROCESSED) },
  { id: 'error', label: 'エラー', value: String(OTA_PENDING_STATUS.ERROR) },
  { id: 'skipped', label: 'スキップ', value: String(OTA_PENDING_STATUS.SKIPPED) },
]

// フィルター用ステータスオプション（未処理のみ）
export const OTA_PENDING_FILTER_STATUS_OPTIONS = [
  { id: 'all', label: 'すべて', value: '' },
  { id: 'draft', label: '下書き', value: String(OTA_PENDING_STATUS.DRAFT) },
  { id: 'ready', label: '準備OK', value: String(OTA_PENDING_STATUS.READY) },
  { id: 'processed', label: '処理済み', value: String(OTA_PENDING_STATUS.PROCESSED) },
  { id: 'error', label: 'エラー', value: String(OTA_PENDING_STATUS.ERROR) },
  { id: 'skipped', label: 'スキップ', value: String(OTA_PENDING_STATUS.SKIPPED) },
]

// 販売元オプション
export const OTA_PENDING_SELLER_OPTIONS = [
  { id: 'all', label: 'すべて', value: '' },
  { id: 'airbnb', label: 'Airbnb', value: 'airbnb' },
  { id: 'klook', label: 'Klook', value: 'klook' },
]

// process_action オプション
export const OTA_PENDING_PROCESS_ACTION_OPTIONS = [
  { id: 'new', label: '新規作成', value: 'new' },
  { id: 'cancel', label: 'キャンセル', value: 'cancel' },
]

// チャネルマネージャー/販売元の選択肢
export const CHANNEL_SELLER_OPTIONS = [
  { value: 'airbnb', label: 'airbnb' },
  { value: 'klook', label: 'klook' },
  { value: 'other', label: 'other' },
]

// 時間の選択肢 (05-23)
export const HOUR_OPTIONS = Array.from({ length: 19 }, (_, i) => {
  const hour = String(i + 5).padStart(2, '0')
  return { value: hour, label: hour }
})

// 分の選択肢 (0, 15, 30, 45)
export const MINUTE_OPTIONS = [
  { value: '00', label: '00' },
  { value: '15', label: '15' },
  { value: '30', label: '30' },
  { value: '45', label: '45' },
]

// ステータスラベル取得関数
export const normalizeOtaPendingStatus = (statusId: number | string): number => {
  if (typeof statusId === 'number') {
    return statusId
  }
  const parsed = parseInt(statusId, 10)
  if (!Number.isNaN(parsed)) {
    return parsed
  }
  return OTA_PENDING_STATUS_KEYS[statusId] || 0
}

export const getOtaPendingStatusLabel = (statusId: number | string): string => {
  const id = normalizeOtaPendingStatus(statusId)
  return OTA_PENDING_STATUS_LABELS[id] || ''
}

// 参加者数オプション（0-25）
export const NUM_OF_PEOPLE_OPTIONS = Array.from({ length: 26 }, (_, i) => ({
  id: String(i),
  label: String(i),
  value: String(i),
}))

// 通貨オプション
export const CURRENCY_OPTIONS = [
  { id: 'JPY', label: 'JPY', value: 'JPY' },
  { id: 'USD', label: 'USD', value: 'USD' },
  { id: 'EUR', label: 'EUR', value: 'EUR' },
]

// ステータスバッジの背景色
export const getStatusBadgeBackgroundColor = (status: number): string => {
  switch (status) {
    case OTA_PENDING_STATUS.DRAFT:
      return '#e0e0e0'
    case OTA_PENDING_STATUS.READY:
      return '#4caf50'
    case OTA_PENDING_STATUS.PROCESSED:
      return '#2196f3'
    case OTA_PENDING_STATUS.ERROR:
      return '#f44336'
    case OTA_PENDING_STATUS.SKIPPED:
      return '#9e9e9e'
    default:
      return '#e0e0e0'
  }
}

// ステータスバッジの文字色
export const getStatusBadgeTextColor = (status: number): string => {
  switch (status) {
    case OTA_PENDING_STATUS.DRAFT:
      return '#333'
    case OTA_PENDING_STATUS.READY:
    case OTA_PENDING_STATUS.PROCESSED:
    case OTA_PENDING_STATUS.ERROR:
    case OTA_PENDING_STATUS.SKIPPED:
      return '#fff'
    default:
      return '#333'
  }
}
